// Tab slugs: "oversikt" (default — class table)
import { useState } from 'react'
import { useLatest } from '../useLatest'
import { useBruktbilFilters } from '../useBruktbilFilters'
import { fetchKlasserTable } from './api'
import type { KlasserListResponse } from './api'
import KlasserTable from './KlasserTable'

export default function KlasserPage() {
  const { from, to, klasse, varebil, omregistrering, selgerPostnummer, kjoperPostnummer } = useBruktbilFilters()
  const [tableData, setTableData] = useState<KlasserListResponse | null>(null)
  const [tableLoading, setTableLoading] = useState(false)

  useLatest(alive => {
    setTableLoading(true)
    fetchKlasserTable({ from, to, klasse, varebil, omregistrering, selgerPostnummer, kjoperPostnummer })
      .then(res => { if (alive()) setTableData(res.data) })
      .finally(() => { if (alive()) setTableLoading(false) })
  }, [from, to, JSON.stringify(klasse), varebil, omregistrering, selgerPostnummer, kjoperPostnummer])

  return (
    <div className="space-y-3">
      {tableLoading && (
        <div className="card p-4 animate-pulse h-40 bg-gray-100 dark:bg-dark-border rounded-sm" />
      )}
      {!tableLoading && tableData && (
        <KlasserTable rows={tableData.rows} />
      )}
    </div>
  )
}
